export default __webpack_public_path__ + "assets/fashion.ee4bc8.png";